var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.1 39",
    style: {
      enableBackground: "new 0 0 39.1 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#007B7B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-3",
    transform: "translate(14.29 15.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "st0",
    d: "M10.8-6h-3c-2.8,0-5,2.2-5,5v3h-3v4h3v8h4V6h3l1-4h-4v-3c0-0.6,0.4-1,1-1h3V-6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-Facebook.bd07255d2f336a3456a8b7e863d5a91e.svg";
export { ForwardRef as ReactComponent };